import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { PropertyProfileService } from '../property-profile/property-profile.service';
import { PropertyProfile } from '../property-profile/property-profile';
import { PropertyProfileComponent } from '../property-profile/property-profile/property-profile.component';
import { OnboardingTasksDialogComponent } from './onboarding-tasks-dialog/onboarding-tasks-dialog.component';
import { TaskService } from '@app/_components/task';

@Component({
    selector: 'app-property-profile-onboarding-list',
    templateUrl: './property-profile-onboarding-list.component.html',
    styleUrls: ['./property-profile-onboarding-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class PropertyProfileOnboardingListComponent implements OnInit {

  realEstateStatuses: any;
  onboardingTaskMap: { [propertyCode: string]: any } = {};

	constructor(
		private propertyProfileService: PropertyProfileService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		private taskService: TaskService,
	) {
		this.realEstateStatuses = propertyProfileService.realEstateStatuses
	}



	// data
	propertyProfiles: any;
	propertyProfile: PropertyProfile;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	columns: any[] = [
		{ field: 'shortTermRentalVO.propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'ownerProfileVOList.lastName', header: 'Owner Last Name', width: 'auto' },
		{ field: 'realEstateStatus', header: 'Real Estate Status', width: 'auto' },
		{ field: 'ambassadorUserVO.lastName ', header: 'Ambassador LastName', width: 'auto' },
    { field: 'trnsInEffectiveDate', header: 'Trns In Effective Date', width: 'auto' },
		{ field: 'trnsInReason', header: 'Trns In Reason', width: 'auto' },
		{ field: 'trnsInNewMgrName', header: 'Trns In New Mgr Name', width: 'auto' },
		{ field: 'trnsInReasonDesc', header: 'Trns In Reason Desc', width: 'auto' },
	];

	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'description': [
			{ type: 'required', message: 'Required' }
		],
	}

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	getFilteredTags(tags) {
		//if filter text input is empty then load all records
		if(tags == '0') {
			delete this.lazyLoadEvent.filters.propertyProfileId;
			this.loadLazy(this.lazyLoadEvent, true);
		} else {
			//If records found then show filtered records
			if(tags.length > 0) {
				//if filter text input is not empty then load filtered records only
				var filteredIds = [];
				tags.forEach(tag => {
					filteredIds.push(tag.tagSourceId);
				});
				let activityProviderIdFilter = { 'propertyProfileId': { 'value': filteredIds, 'matchMode': 'in' } };
				Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
				this.loadLazy(this.lazyLoadEvent, true);
			} else {
				//Display empty table as no record found with filtered input
				this.propertyProfiles = [];
			}
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.propertyProfileId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent, isLoading: any) {
		try {
			if(!isLoading){
				this.loading = true;
			}
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-propertyProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			let realEstateStatusFilter = { 'realEstateStatus': { 'value': '3', 'matchMode': 'in' } };
				Object.assign(event.filters, realEstateStatusFilter);

			const pageNumber = Math.round(event.first / event.rows);
			this.propertyProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.propertyProfiles = res.data.propertyProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.propertyProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(propertyProfile: PropertyProfile) {
		try {
			this.formLoading = true;
			this.propertyProfileService.update(propertyProfile)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.propertyProfiles.map((propertyProfile, i) => {
							if (propertyProfile.propertyProfileId === res.data.propertyProfile.propertyProfileId) {
								this.propertyProfiles[i] = res.data.propertyProfile;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(propertyProfile: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(propertyProfile));

			this.formLoading = true;
			this.propertyProfileService.delete(propertyProfile.propertyProfileId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.propertyProfiles.splice(this.propertyProfiles.indexOf(propertyProfile), 1);
						this.recordTotal = this.propertyProfiles.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'PropertyProfile ' + propertyProfile.propertyProfileId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'PropertyProfile ' + propertyProfile.propertyProfileId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add PropertyProfile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.addPropertyProfileCB(data);
				
				this.loadLazy(this.lazyLoadEvent, true);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(propertyProfile: PropertyProfile) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			propertyProfile: propertyProfile,
			title: 'Edit PropertyProfile'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(PropertyProfileComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.updatePropertyProfileCB(data);
				
				this.loadLazy(this.lazyLoadEvent, true);

				// close the dialogBox
				//dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deletePropertyProfileCB(data);

				// close the dialogBox
				dialogRef.close();
			});

			dialogRef.componentInstance.doUpdateShowResIncomeFlag.subscribe(
				data => {
					console.log('Dialog output:', data);
					this.loadLazy(this.lazyLoadEvent, false);
				});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPropertyProfileCB(propertyProfile: PropertyProfile) {
		console.log('Adding PropertyProfile: ' + JSON.stringify(propertyProfile));
		// if we don't have a propertyProfiles array yet...
		if (!this.propertyProfiles) {
			this.propertyProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.propertyProfiles.unshift(propertyProfile);

		// no idea what this is but it is required to update the array
		this.propertyProfiles = [...this.propertyProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyProfile ' + propertyProfile.propertyProfileId + ' Added', life: 3000 });
	}

	updatePropertyProfileCB(propertyProfile: PropertyProfile) {
		console.log('Updating PropertyProfile: ' + JSON.stringify(propertyProfile));
		let itemIndex = this.propertyProfiles.findIndex((item: any) => item.propertyProfileId === propertyProfile.propertyProfileId);
		this.propertyProfiles[itemIndex] = propertyProfile;

		// no idea what this is but it is required to update the array
		this.propertyProfiles = [...this.propertyProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyProfile ' + propertyProfile.propertyProfileId + ' Updated', life: 3000 });
	}

	deletePropertyProfileCB(propertyProfile: PropertyProfile) {
		console.log('Removing PropertyProfile: ' + propertyProfile);
		this.propertyProfiles.splice(this.propertyProfiles.indexOf(propertyProfile), 1);
		this.recordTotal = this.propertyProfiles.length;

		// no idea what this is but it is required to update the array
		this.propertyProfiles = [...this.propertyProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PropertyProfile ' + propertyProfile.propertyProfileId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.propertyProfiles ? this.first === (this.propertyProfiles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.propertyProfiles ? this.first === 0 : true; }

	openOnboardingTasks(propertyProfile: any): void {
		const code = propertyProfile?.propertyCode || '';
		const existingTask = this.onboardingTaskMap[code] || null;

		const dialogConfig = new MatDialogConfig();
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = false;
		dialogConfig.hasBackdrop = true;
		dialogConfig.data = {
			propertyProfile: propertyProfile,
			parentTask: existingTask,
		};

		const dialogRef = this.dialog.open(OnboardingTasksDialogComponent, dialogConfig);

		dialogRef.afterClosed().subscribe(result => {
			if (result?.parentTask && code) {
				this.onboardingTaskMap[code] = result.parentTask;
				this.onboardingTaskMap = { ...this.onboardingTaskMap };
			}
		});
	}

	get Statuses() {
		return this.realEstateStatuses;
	}

	getStatusName(propertyProfile: any) {
		if (propertyProfile?.realEstateStatus) {
			const status = this.realEstateStatuses.find((e: any) => e.value == propertyProfile.realEstateStatus);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}

	getGigStatusName(gigStatus: any){
		if(gigStatus != undefined && gigStatus != null && gigStatus != "" && gigStatus == 1){
			return "true";
		}else{
			return "";
		}
	}

}
